import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Link from "@mui/material/Link";
import RefreshIcon from "@mui/icons-material/Refresh";
import Table from "../blocks/table";
import { useTenancy } from "../../../services/tenancy";
import { useApiCentral } from "../../../api/api-central";
import { useApiTenant } from "../../../api/api-tenant";
export default function LogsTable({ type, title }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const tenancy = useTenancy();
    const api = type == "client" ? useApiTenant() : useApiCentral();
    const tableRef = useRef();
    const [isLoading, setIsLoading] = useState(true);
    const [tableQuery, setTableQuery] = useState();
    const isMobile = useMediaQuery("(max-width: 767px)");
    if (type == "client") {
        useEffect(() => {
            if (!tenancy.client)
                return;
            refreshTableData();
        }, [tenancy.client]);
    }
    const getTableData = query => {
        setTableQuery(query);
        return new Promise(resolve => {
            setIsLoading(true);
            api.GET_logs(query.pageSize, query.page + 1, query.orderBy ? query.orderBy.field : "id", query.orderDirection ? query.orderDirection : "desc", query.search ? query.search : null)
                .then(response => {
                resolve({
                    data: response.data.activity_logs,
                    page: response.data.meta.current_page - 1,
                    totalCount: response.data.meta.total,
                });
            })
                .catch(error => {
                console.error(error);
            })
                .finally(() => {
                setIsLoading(false);
            });
        });
    };
    const refreshTableData = () => {
        var _a;
        // @ts-ignore
        (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.onQueryChange();
    };
    return (_jsx(Table, { title: title, actions: [
            {
                icon: () => _jsx(RefreshIcon, { color: "action" }),
                tooltip: t("logs.refresh-logs"),
                isFreeAction: true,
                onClick: () => refreshTableData(),
            },
        ], columns: isMobile
            ? [
                {
                    title: t("logs.log") + " #",
                    field: "id",
                    defaultSort: "desc",
                },
            ]
            : [
                {
                    maxWidth: "80px",
                    title: "#",
                    field: "id",
                    type: "numeric",
                    defaultSort: "desc",
                },
                {
                    title: "Description",
                    sorting: false,
                    field: "description",
                },
                {
                    title: "Subject Type",
                    sorting: false,
                    render: log => {
                        return log.subject_type
                            .replace("App\\Models\\Tenant\\", "")
                            .replace("App\\Models\\Central\\", "")
                            .replace("App\\Models\\General\\", "")
                            .replace("Custom\\", "")
                            .replace("Data", "")
                            .replace("TenantUser", "User")
                            .replace("CentralUser", "User")
                            .replace("Tenant", "Client")
                            .replace("ClientGroup", "Group")
                            .replace("KnowledgeModule", "Knowledge")
                            .replace(/^(.*?)Data/, "CustomFieldInput")
                            .replace("Items\\ArrayTextItem", "CustomFieldItem")
                            .replace("Items\\ArrayImageTextItem", "CustomFieldItem")
                            .replace("Info\\RatingInfo", "SharedFormCustomField");
                    },
                },
                {
                    title: "Subject ID",
                    sorting: false,
                    field: "subject_id",
                },
                {
                    title: "Causer",
                    sorting: false,
                    render: log => {
                        return log.causer_id ? (log.central_user ? (_jsx(Link, Object.assign({ href: "/administration/users/" + log.central_user.id, onClick: event => {
                                event.preventDefault();
                                navigate("/administration/users/" + log.central_user.id);
                            }, underline: "hover" }, { children: log.central_user.first_name +
                                (log.central_user.last_name
                                    ? " " + log.central_user.last_name
                                    : "") }))) : log.tenant_user ? (_jsx(Link, Object.assign({ href: tenancy.link("/settings/users/" + log.tenant_user.id), onClick: event => {
                                event.preventDefault();
                                navigate(tenancy.link("/settings/users/" + log.tenant_user.id));
                            }, underline: "hover" }, { children: log.tenant_user.first_name +
                                (log.tenant_user.last_name
                                    ? " " + log.tenant_user.last_name
                                    : "") }))) : (log.causer_id)) : ("System");
                    },
                },
                {
                    title: "Timestamp",
                    width: "200px",
                    render: log => {
                        return new Date(Date.parse(log.updated_at)).toLocaleString();
                    },
                },
            ], data: query => getTableData(query), isLoading: isLoading, tableRef: tableRef, tableQuery: tableQuery, disableSearch: true }));
}
